import axios from "../../components/api/api";
import { ranchApi, surveyApi } from "../../components/api";

const setAuthToken = token => {
    if (token) {
        axios.defaults.headers.common.authorization = token;
        ranchApi.defaults.headers.common.Authorization = token;
        surveyApi.defaults.headers.common.Authorization = token;
    } else {
        delete axios.defaults.headers.common.authorization;
        delete ranchApi.defaults.headers.common.Authorization;
        delete surveyApi.defaults.headers.common.Authorization;
    }
};
export default setAuthToken;
